export const STATUS_FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'outstanding', label: 'Outstanding' },
  { key: 'paid', label: 'Paid' },
];

export const TYPE_OPTIONS = [
  { key: 'treatment', label: 'Treatment Plan' },
  { key: 'charge', label: 'Manual Charge' },
];

const PAYMENTABLE_TYPES = {
  treatment: 'FinancialArrangement',
  charge: 'Charge',
};

export const getBillingParams = (statusFilter, selectedTypes) => {
  const q: any = {};

  if (statusFilter === 'outstanding') q.state_eq = 'unpaid';
  if (statusFilter === 'paid') q.state_eq = 'paid';

  // paymentable_type_eq takes a single value, so only send it when exactly one type is selected
  if (selectedTypes.length === 1) q.paymentable_type_eq = PAYMENTABLE_TYPES[selectedTypes[0]];

  return { q };
};
